module.exports = __webpack_public_path__ + "img/vlcsnap-2016-03-22-13.08f515d2.png";